import axios from 'axios'
import { API_BASE_URL } from './../utils/config.js' 
import { obtenerToken, guardarToken, obtenerRefreshToken, eliminarToken, eliminarRefreshToken } from './../utils/authUtils.js' 
import { manejarError } from './../utils/errorUtils.js'

const INACTIVIDAD_MAXIMA = 7200000 //2 horas

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Accept': 'application/json',
  }
})

const verificarInactividad = () => {
  const ultimaActividad = localStorage.getItem('ultimaActividad')
  
  // Si no existe la variable ultimaActividad, no se puede verificar inactividad, entonces no hacemos nada
  if (!ultimaActividad) {
    return true // Continuamos normalmente
  }

  const tiempoInactividad = Date.now() - parseInt(ultimaActividad)
  if (tiempoInactividad > INACTIVIDAD_MAXIMA) {
    eliminarToken()
    eliminarRefreshToken()
    localStorage.removeItem('ultimaActividad') 
    window.location.href = "/" // Redirige a login
    return false
  }

  // Si no ha pasado el tiempo de inactividad, actualiza la última actividad
  localStorage.setItem('ultimaActividad', Date.now())
  return true
}


// Función genérica para hacer peticiones API con manejo de Refresh Token
export const consumirApi = async (method, url, data = null) => {
  // Verificamos la inactividad antes de hacer la petición
  if (!verificarInactividad()) {
    return { success: false, error: "Sesión expirada. Inicie sesión nuevamente." }
  }

  const token = obtenerToken()
  const config = { 
    headers: { 
      'Authorization': token ? `Bearer ${token}` : ''
    }
  }

  try {
    let response

    if (method === 'GET') {
      response = await api.get(url, config)
    } else if (method === 'POST') {
      response = await api.post(url, data, config)
    } else if (method === 'PATCH') {
      response = await api.patch(url, data, config)
    } else if (method === 'DELETE') {
      response = await api.delete(url, config)
    }

    return { success: true, data: response.data }
  } catch (error) {
    if (error.response?.status === 401) {
      try {
        // Intentar refrescar el token usando el refresh_token
        const refreshToken = obtenerRefreshToken() // Obtener el refresh token desde localStorage
        if (!refreshToken) {
          return { success: false, error: "Token de refresco no disponible. Inicie sesión nuevamente." }
        }

        const refreshResp = await api.post('refresh', { refresh_token: refreshToken })
        const newToken = refreshResp.data.token

        // Guardar el nuevo token en localStorage
        guardarToken(newToken) 

        // Definir correctamente retryConfig con el nuevo token
        const retryConfig = { 
          ...config, 
          headers: { 'Authorization': `Bearer ${newToken}` }
        }

        let retryResponse
        if (method === 'GET') {
          retryResponse = await api.get(url, retryConfig)
        } else if (method === 'POST') {
          retryResponse = await api.post(url, data, retryConfig)
        } else if (method === 'PATCH') {
          retryResponse = await api.patch(url, data, retryConfig)
        } else if (method === 'DELETE') {
          retryResponse = await api.delete(url, retryConfig)
        }

        return { success: true, data: retryResponse.data }
      } catch (refreshError) {
        // Si el refresh también falla, cerrar sesión
        eliminarToken() // Eliminar el access_token y refresh_token
        eliminarRefreshToken() // Aseguramos de eliminar el refresh_token
    
      }
    }

    return { success: false, error: manejarError(error) }
  }
}
